<template>
  <div class="w-full rounded-lg">
    <v-row no-gutters class="mx-0">
      <v-col cols="3">
        <div
          class="rounded-lg"
          :style="{ backgroundImage: `url(${images.cover})` }"
          style="
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-color: #f1f1f1;
            aspect-ratio: 16 / 9;
          "
        ></div>
      </v-col>
      <v-col cols="9" style="position: relative">
        <v-chip
          label
          small
          :color="party.ageGroup == 0 ? 'success' : 'info'"
          style="position: absolute; right: 0px; top: 0px"
          class="font-weight-medium"
        >
          <span style="color: white">
            {{ party.ageGroup == 0 ? "Livre" : `+${party.ageGroup}` }}
          </span>
        </v-chip>
        <div class="d-flex flex-grow-1 flex-column px-4 h-full justify-center">
          <h4 class="text-truncate mb-0 black--text">
            {{ party?.name }}
          </h4>
          <div class="d-flex flex-column gap-1">
            <div class="d-flex align-center">
              <span class="text-body-1 lh-1"
                >{{ party.date | formatDate }} até
                {{ party.endDate | formatDate }}</span
              >
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <div class="d-flex gap-4 black--text mt-3 ml-1">
      <div class="flex-grow-1 d-flex flex-column lh-1">
        <h6 class="mb-2">Detalhes do evento</h6>
        <div>
          <b>Faixa Etária</b>
          <p class="mb-0 text--secondary lh-4">
            <age-group-text :party="party" class="black--text" hide-download />
          </p>
        </div>
        <div v-if="party?.requireDocuments">
          <v-divider class="my-2" />
          <b>Documentos necessários</b>
          <p class="mb-0 black--text lh-4">
            {{ party.requireDocuments }}
          </p>
        </div>

        <div v-if="party?.dressCode">
          <v-divider class="my-2" />
          <b>Normas de vestimenta</b>
          <p class="mb-0 black--text lh-4">
            {{ party.dressCode }}
          </p>
        </div>
        <div>
          <v-divider class="my-2" />
          <b>Organizador</b>
          <p class="mb-0 black--text lh-4">
            {{ party.Organization.name }}
          </p>
        </div>
      </div>
      <v-card elevation="0" class="align-self-end pa-1 pb-0 rounded">
        <div style="position: relative">
          <qrcode-vue
            style="
              background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=);
              background-size: cover;
            "
            class="d-flex justify-center white rounded"
            :value="partyLink"
            size="70"
            level="M"
            renderAs="svg"
          />
          <div
            class="d-flex justify-center align-center"
            style="position: absolute; top: 0; right: 0; bottom: 0; left: 0"
          >
            <v-avatar size="18" color="white">
              <v-icon size="14" color="primary"> mdi-web </v-icon>
            </v-avatar>
          </div>
        </div>

        <small class="text-center d-block" style="font-size: 9px">
          Detalhes evento
        </small>
      </v-card>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import AgeGroupText from "../../global/party/AgeGroupText.vue";
import moment from "moment";
export default {
  components: {
    QrcodeVue,
    AgeGroupText,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {
    partyLink() {
      return `${window.location.origin}/shop/${this.party.Organization.slug}/${
        this.party.slug || this.party.id
      }`;
    },
  },

  filters: {
    formatDate(date) {
      const momentDate = moment(date);
      var formatPattern = "DD [de] MMM";

      if (momentDate.year() != moment().year()) formatPattern += " [de] YYYY";
      else if (momentDate.isBefore(moment(), "day"))
        formatPattern += " [de] YYYY";

      formatPattern += " [às] HH[h]mm";

      return momentDate.format(formatPattern).replace("h00", "h");
    },
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
    images: {
      type: Object,
      required: true,
    },
    fullAddress: {
      type: String,
    },
    geometry: {
      type: Object,
    },
  },
};
</script>

<style scoped>
p {
  display: block;
}
</style>
